import { generateId } from '@witkac/utils'

import type { ConfirmOptions } from '../../typings/confirmOptions'

/**
 * Potwierdzenie
 *
 * @export
 * @class Confirm
 */
export class Confirm {
  /**
   * Identyfikator
   *
   * @type {string}
   * @memberof Confirm
   */
  public id: string

  /**
   * Wynik potwierdzenia
   *
   * @type {Promise<boolean>}
   * @memberof Confirm
   */
  public result: Promise<boolean>

  /**
   * Akceptacja potwierdzenia
   *
   * @memberof Confirm
   */
  public accept!: () => void

  /**
   * Odrzucenie potwierdzenia
   *
   * @memberof Confirm
   */
  public reject!: () => void

  constructor(
    public message: string,
    public options?: ConfirmOptions,
  ) {
    this.id = generateId('confirm')
    this.result = new Promise((resolve, reject) => {
      this.accept = () => resolve(true)
      this.reject = () => reject(false)
    })
  }
}
